import FeatherIcon from 'feather-icons-react';
import { Button } from 'react-bootstrap';
import toast, { Toast, Toaster, ToastPosition } from 'react-hot-toast';

export enum NotificationKinds {
  ERROR = 'error',
  SUCCESS = 'success'
}

enum NotificationStyles {
  DANGER = 'danger',
  SUCCESS = 'success'
}

interface NotificationProps {
  variant: NotificationKinds;
  title: string;
  subtitle?: string | JSX.Element;
  position?: ToastPosition;
}

type NotificationStyleMap = {
  [K in NotificationKinds]: NotificationStyles;
};

const styleMap: NotificationStyleMap = {
  [NotificationKinds.ERROR]: NotificationStyles.DANGER,
  [NotificationKinds.SUCCESS]: NotificationStyles.SUCCESS
};

export const notification = ({ variant, title, subtitle }: NotificationProps) => {
  const toastNotification = toast.custom((t: Toast) => (
    <div
      className={`rounded bg-white border border-${styleMap[variant]} py-4 px-4 d-flex justify-content-between`}
      style={{ width: 355 }}
    >
      <div>
        <h4 className="mb-0">{title}</h4>
        {subtitle && <p className="mt-2 fs-4 mb-0">{subtitle}</p>}
      </div>
      <div className="mb-n2">
        <Button
          variant="white"
          className="rounded-circle border-0 p-0 mt-n3 text-muted"
          onClick={() => toast.remove(t.id)}
        >
          <FeatherIcon icon="x" size={16} />
        </Button>
      </div>
    </div>
  ));

  return toastNotification;
};

export const Notifications = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 5000
      }}
    />
  );
};
